import {
  Container,
  DescriptionSkeletonLoader,
  Header,
  TagSkeleton
} from './style';

const ConsumptionMetaDataSkeletonLoader = () => {
  return (
    <Container>
      <Header />
      <TagSkeleton />
      <DescriptionSkeletonLoader />
    </Container>
  );
};

export default ConsumptionMetaDataSkeletonLoader;
